import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { addCountry, logOutApi } from '../../../Context/api';
import { countryValidation } from '../../../Context/validation';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UseAddCountry = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId,userId:adminData.userId,type:'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const countryAdd = useFormik({
        initialValues: {
            code: '',
            name: ''
        },
        validationSchema: countryValidation,
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                code: values.code.trim(),
                createdby_id: adminData.userId
            }
            setSpinner(true)
            axios.post(addCountry(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    countryAdd.resetForm()
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })
        }
    })
  return {
    spinner,
    countryAdd
  }
}

export default UseAddCountry